var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.998 16C11.446 16 10.998 15.552 10.998 15C10.998 14.448 11.446 14 11.998 14C12.55 14 12.998 14.448 12.998 15C12.998 15.552 12.55 16 11.998 16ZM11.998 12C10.344 12 8.99805 13.346 8.99805 15C8.99805 16.654 10.344 18 11.998 18C13.652 18 14.998 16.654 14.998 15C14.998 13.346 13.652 12 11.998 12ZM17.998 19C17.998 19.552 17.55 20 16.998 20H6.99805C6.44605 20 5.99805 19.552 5.99805 19V11C5.99805 10.448 6.44605 10 6.99805 10H7.99805H9.99805H13.998H15.998H16.998C17.55 10 17.998 10.448 17.998 11V19ZM9.99805 6.111C9.99805 4.947 10.895 4 11.998 4C13.101 4 13.998 4.947 13.998 6.111V8H9.99805V6.111ZM16.998 8H15.998V6.111C15.998 3.845 14.204 2 11.998 2C9.79205 2 7.99805 3.845 7.99805 6.111V8H6.99805C5.34405 8 3.99805 9.346 3.99805 11V19C3.99805 20.654 5.34405 22 6.99805 22H16.998C18.652 22 19.998 20.654 19.998 19V11C19.998 9.346 18.652 8 16.998 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.4fd255d52f30533093384644e48edf4d.svg";
export { ForwardRef as ReactComponent };